import * as Yup from 'yup';
export const addUserValidationSchema = Yup.object().shape({
    hierarchyLevel: Yup.string(),
    partnerOfPartner: Yup.string().when(['hierarchyLevel'], {
        is: (hierarchyLevel) => hierarchyLevel === 'Partner of Partner',
        then: Yup.string().required('Select Partner of Partner'),
        otherwise: Yup.string(),
    }),
    merchant: Yup.string().when(['hierarchyLevel'], {
        is: (hierarchyLevel) => hierarchyLevel === 'Merchant',
        then: Yup.string().required('Select Merchant'),
        otherwise: Yup.string(),
    }),
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
    mobileNumber: Yup.string().required('Mobile number is required'),
    email: Yup.string().email('Email must be of type email').required('Enter Email'),
    userRole: Yup.string().required('Select User role'),
    worldPaySeller: Yup.boolean(),
    sellerId: Yup.string().when('worldPaySeller', {
        is: (worldPaySeller) => worldPaySeller === true,
        then: Yup.string().required('Enter Seller ID'),
    }),
    pipeDrive: Yup.boolean(),
    pipeDriveUserId: Yup.string().when('pipeDrive', {
        is: (pipeDrive) => pipeDrive === true,
        then: Yup.string().required('Enter Pipe Drive User ID'),
    }),
    technicalSupportAccess: Yup.boolean(),
    zenDeskUserId: Yup.string().when('technicalSupportAccess', {
        is: (technicalSupportAccess) => technicalSupportAccess === true,
        then: Yup.string().required('Enter ZenDesk User ID'),
    }),
});
